<script lang="ts">
    import type { PostQuery, Posts_Default_Entry } from '$gen/graphql';
    import ImagePair from '$lib/components/blocks/ImagePair.svelte';

    import InstagramPosts from '$lib/components/blocks/InstagramPosts.svelte';
    import InterviewBlock from '$lib/components/blocks/InterviewBlock.svelte';

    import SingleImage from '$lib/components/blocks/SingleImage.svelte';
    import SingleImageSmall from '$lib/components/blocks/SingleImageSmall.svelte';
    import TextBlock from '$lib/components/blocks/TextBlock.svelte';
    import VideoBlock from '$lib/components/blocks/VideoBlock.svelte';
    import ImageSlider from '$lib/components/carousel-image-slider/ImageSlider.svelte';

    type Post = Extract<PostQuery['entry'], { __typename: 'posts_default_Entry' }>;

    export let block: Post['contentBlocks'][number];

    type Slide = Extract<
        Extract<
            Extract<
                PostQuery['entry'],
                { __typename: 'posts_default_Entry' }
            >['contentBlocks'][number],
            { __typename: 'contentBlocks_Slider_BlockType' }
        >['slides'][number],
        { __typename: 'assets_Asset' }
    >;
    const isAssetsAsset = (item): item is Slide => (item as Slide).__typename === 'assets_Asset'; // Type guard to prove to the ts compiler that this is assets_Asset type.
</script>

{#if block.__typename === 'contentBlocks_image_BlockType'}
    {#if block.image[0].__typename === 'assets_Asset'}
        {#if block.kind === 'big'}
            <SingleImage
                src={block.image[0].url}
                srcset={block.image[0].srcset}
                width={block.image[0].width}
                height={block.image[0].height}
                description={block.image[0].description}
            />
        {:else if block.kind === 'small'}
            <SingleImageSmall
                src={block.image[0].url}
                srcset={block.image[0].srcset}
                width={block.image[0].width}
                height={block.image[0].height}
                description={block.image[0].description}
            />
        {/if}
    {/if}
{:else if block.__typename === 'contentBlocks_imagePair_BlockType'}
    {#if block.leftImage[0].__typename === 'assets_Asset' && block.rightImage[0].__typename === 'assets_Asset'}
        {#if block.kind === 'big'}
            <ImagePair imgLeft={block.leftImage[0]} imgRight={block.rightImage[0]} />
        {:else if block.kind === 'small'}
            <ImagePair imgLeft={block.leftImage[0]} imgRight={block.rightImage[0]} />
        {/if}
    {/if}
{:else if block.__typename === 'contentBlocks_textBlock_BlockType'}
    <TextBlock text={block.text} />
{:else if block.__typename === 'contentBlocks_interview_BlockType'}
    <InterviewBlock content={block} />
{:else if block.__typename === 'contentBlocks_Slider_BlockType'}
    <ImageSlider images={block.slides.filter(isAssetsAsset)} />
{:else if block.__typename === 'contentBlocks_instagram_BlockType'}
    <InstagramPosts instaPosts={block} />
{:else if block.__typename === 'contentBlocks_video_BlockType'}
    <VideoBlock {block} />
{/if}
